import React from "react"
import { LinkType } from "../../../types"
import { LinkListPropsType } from "./types"

const Link: any = React.lazy(() => import("../link"))

const LinkList = ({ pk, ...props }: LinkListPropsType) => {
  return (
    <ul className={props.className}>
      {props.links.map((link: LinkType, k: number) => (
        <li key={`LinkList${pk}-${k}`}>
          <Link {...link}>{props.children}</Link>
        </li>
      ))}
    </ul>
  )
}
export default LinkList
